import PropTypes from 'prop-types';
export const badgePropTypes = {
  /**
   * Label value
   */
  badge: PropTypes.string,
  /**
   * classname value
   */
  classname: PropTypes.string
};